export type TabId = 'bot' | 'whatsapp' | 'messenger';

export interface Message {
  id: string;
  role: 'bot' | 'user';
  text: string;
  chips?: string[];
  timestamp: Date;
}

export interface FaqEntry {
  id: string;
  question: string;
  answer: string;
  keywords: string[];
  display_order: number;
  is_active: boolean;
}

export interface ChatSettings {
  whatsapp_number: string;
  whatsapp_prefill: string;
  messenger_page_id: string;
  fb_chat_plugin_enabled: boolean;
  enabled_tabs: TabId[];
  widget_enabled: boolean;
}

export const DEFAULT_CHAT_SETTINGS: ChatSettings = {
  whatsapp_number: '',
  whatsapp_prefill: 'Hi, I have a question about Protein Meals!',
  messenger_page_id: '',
  fb_chat_plugin_enabled: false,
  enabled_tabs: ['bot', 'whatsapp', 'messenger'],
  widget_enabled: true,
};

export interface UpcomingOrderStatus {
  pending_assignment?: boolean;
  subscription_status?: 'active' | 'past_due' | 'paused' | 'none';
  order?: {
    id: string;
    status: 'pending' | 'confirmed' | 'preparing' | 'out_for_delivery' | 'delivered' | 'cancelled';
    is_chefs_choice: boolean;
    meal_ids: string[] | null;
    monday_meal_count: number | null;
  } | null;
  week_start_date?: string;
  message?: string;
  error?: string;
}
